import { ABaseElement } from "./abaseelement.model";
import { TranslatedString } from "../translatedstring.model";
import { Type } from "class-transformer";
// @dynamic
export class DataModel extends ABaseElement {
    @Type(() => TranslatedString)
    Description: TranslatedString;
}